<template>
	<div class="alert_bg">
		<div class="alert_body">
			<div class="close_btn" @click="onCancelClick"></div>
			<div class="tips_title">今日剩余连接次数</div>
			<div class="tips_value">{{ times }}</div>
			<div class="sure_btn" @click="onCancelClick">确定</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
	props: ["times"],
	data: function () {
		return {
			isShowSpeed: false,
			isShowVip: false,
		};
	},
	methods: {
		...mapActions(["sendUserlog"]),
		showSpeed: function () {
			this.isShowSpeed = true;
		},
		hideSpeed: function () {
			this.isShowSpeed = false;
		},
		showVip: function () {
			this.isShowVip = true;
		},
		hideVip: function () {
			this.isShowVip = false;
		},
		onCancelClick: function () {
			let _that = this;
			_that.sendUserlog([
				"service_limit_cancel_click",
				_that.max_services,
			]);
			_that.$emit("onCancelClick");
		},
		onPayClick: function () {
			let _that = this;
			_that.sendUserlog(["service_limit_pay_click", _that.max_services]);
			_that.$emit("onCancelClick");
			_that.$emit("onPayClick");
		},
		onSpeedClick: function () {
			let _that = this;
			_that.sendUserlog([
				"service_limit_speed_click",
				_that.max_services,
			]);
			_that.$emit("onCancelClick");
			_that.$emit("onSpeedClick");
		},
	},
	mounted: function () {
		let _that = this;
		_that.sendUserlog(["service_limit", _that.max_services]);
	},
};
</script>

<style lang="less" scoped>
.alert_bg {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 9;
	.alert_body {
		width: 340px;
		height: 260px;
		left: 50%;
		top: 50%;
		margin-left: -170px;
		margin-top: -130px;
		background-color: #fcfcfc;
		background: linear-gradient(180deg, #fff9f4, #ffffff);
		position: absolute;
		border-radius: 5px;
		.close_btn {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 10px;
			top: 10px;
			background-image: url(../../assets/common/close4.svg);
			background-size: 100% 100%;
			cursor: pointer;
			z-index: 2;
		}
		.close_btn:hover {
			opacity: 0.8;
			cursor: pointer;
		}

		.tips_title {
			text-align: center;
			margin-top: 60px;
			font-size: 14px;
			color: #999999;
		}

		.tips_value {
			text-align: center;
			font-size: 60px;
			height: 80px;
			line-height: 80px;
			margin: 5px auto;
			font-weight: bolder;
			color: #e81818;
		}

		.sure_btn {
			width: 168px;
			height: 48px;
			left: 490px;
			top: 461px;
			text-align: center;
			line-height: 48px;
			color: #ffffff;
			margin: 0 auto;

			background: linear-gradient(
				139.88deg,
				#1f5de3 25.39%,
				#1f85e3 77.13%
			);
			border-radius: 24px;
		}
		.sure_btn:hover {
			cursor: pointer;
			opacity: 0.8;
		}
	}
}
</style>